import { useState } from "react";
import { Article } from "../../../ui/atoms/Article";
import { Category } from "../components/organism/Category";
import { CampaignsList } from "../components/organism/CampaignsList";

export const Campaign = () => {

    const [categorySeleted, setCategorySelected] = useState("collabs");

    return (
        
        <Article className="h-auto flex items-center justify-center">
            <div className="lg:max-w-2xl fixed top-20 z-10">
                <Category 
                    categories={["collabs", "events", "music", "gaming"]}
                    categorySeleted={categorySeleted} 
                    setCategorySelected={setCategorySelected}
                />
            </div>
            <CampaignsList  
                categorySected={categorySeleted}
            />
        </Article>
    )
}